import { isNumber } from 'lodash';
import { useCallback, useMemo } from 'react';
import { ProjectId } from 'api/models';
import { useProjectDetail } from 'data/projects';
import { useAccountDataQuery } from 'queries/account';
import { usePermissionSetDefinitionsForCtxMap } from 'queries/rbac';
export const ProjectResource = (project)=>[
        'Project',
        project
    ];
export const ProjectResourceOrUndefined = (project)=>project != null ? ProjectResource(project) : undefined;
export const FieldResource = (field)=>[
        'Field',
        field
    ];
export const FieldSectionResource = (fieldSection)=>[
        'FieldSection',
        fieldSection
    ];
export const FieldResourceInProject = (project, field)=>[
        'FieldResourceInProject',
        project,
        field
    ];
const useHasAccessToProjectResource = ()=>{
    var _accountData_userProfile_permissions, _accountData_userProfile;
    const { data: permissionSetDefinitionsMap } = usePermissionSetDefinitionsForCtxMap();
    const { data: accountData } = useAccountDataQuery();
    const hasAccessToProjectResource = useCallback((rule, project, actionScope = [])=>{
        var _accountData_userProfile_permissions_projectPermissionBeanMap_project_permissionSet, _accountData_userProfile_permissions_projectPermissionBeanMap_project, _accountData_userProfile_permissions_projectPermissionBeanMap, _accountData_userProfile_permissions, _accountData_userProfile, _project_permissionSet, _permissionSetDefinitionsMap_permissionSetId_permissionMap, _permissionSetDefinitionsMap_permissionSetId;
        if (rule == null) {
            return true;
        }
        const permissionSetId = typeof project === 'number' ? accountData === null || accountData === void 0 ? void 0 : (_accountData_userProfile = accountData.userProfile) === null || _accountData_userProfile === void 0 ? void 0 : (_accountData_userProfile_permissions = _accountData_userProfile.permissions) === null || _accountData_userProfile_permissions === void 0 ? void 0 : (_accountData_userProfile_permissions_projectPermissionBeanMap = _accountData_userProfile_permissions.projectPermissionBeanMap) === null || _accountData_userProfile_permissions_projectPermissionBeanMap === void 0 ? void 0 : (_accountData_userProfile_permissions_projectPermissionBeanMap_project = _accountData_userProfile_permissions_projectPermissionBeanMap[project]) === null || _accountData_userProfile_permissions_projectPermissionBeanMap_project === void 0 ? void 0 : (_accountData_userProfile_permissions_projectPermissionBeanMap_project_permissionSet = _accountData_userProfile_permissions_projectPermissionBeanMap_project.permissionSet) === null || _accountData_userProfile_permissions_projectPermissionBeanMap_project_permissionSet === void 0 ? void 0 : _accountData_userProfile_permissions_projectPermissionBeanMap_project_permissionSet.permissionSetId : project === null || project === void 0 ? void 0 : (_project_permissionSet = project.permissionSet) === null || _project_permissionSet === void 0 ? void 0 : _project_permissionSet.permissionSetId;
        if (permissionSetId == null) {
            return false;
        }
        const permissionRule = permissionSetDefinitionsMap === null || permissionSetDefinitionsMap === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId = permissionSetDefinitionsMap[permissionSetId]) === null || _permissionSetDefinitionsMap_permissionSetId === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId_permissionMap = _permissionSetDefinitionsMap_permissionSetId.permissionMap) === null || _permissionSetDefinitionsMap_permissionSetId_permissionMap === void 0 ? void 0 : _permissionSetDefinitionsMap_permissionSetId_permissionMap[rule];
        if (permissionRule == null || permissionRule.requestScope === 'NONE') {
            return false;
        }
        // if no actionScope is passed, then the user has access to the resource
        if (!actionScope.length) {
            return true;
        }
        // check if passed actionScope is there in permissionRule.actionScope from server
        // actionScope should be the subset of permissionRule.actionScope
        if (actionScope.length && actionScope.every((scope)=>{
            var _permissionRule_actionScopes;
            return permissionRule === null || permissionRule === void 0 ? void 0 : (_permissionRule_actionScopes = permissionRule.actionScopes) === null || _permissionRule_actionScopes === void 0 ? void 0 : _permissionRule_actionScopes.includes(scope);
        })) {
            return true;
        }
        return false;
    }, [
        accountData === null || accountData === void 0 ? void 0 : (_accountData_userProfile = accountData.userProfile) === null || _accountData_userProfile === void 0 ? void 0 : (_accountData_userProfile_permissions = _accountData_userProfile.permissions) === null || _accountData_userProfile_permissions === void 0 ? void 0 : _accountData_userProfile_permissions.projectPermissionBeanMap,
        permissionSetDefinitionsMap
    ]);
    const getRequestScopeForProjectResource = useCallback(({ rule, resourceData })=>{
        var _resourceData__permissionSet, _resourceData_, _permissionSetDefinitionsMap_permissionSetId_permissionMap, _permissionSetDefinitionsMap_permissionSetId;
        if (resourceData == null) {
            return undefined;
        }
        const permissionSetId = (_resourceData_ = resourceData[1]) === null || _resourceData_ === void 0 ? void 0 : (_resourceData__permissionSet = _resourceData_.permissionSet) === null || _resourceData__permissionSet === void 0 ? void 0 : _resourceData__permissionSet.permissionSetId;
        if (permissionSetId == null) {
            return undefined;
        }
        if (rule == null) {
            return undefined;
        }
        const permissionRule = permissionSetDefinitionsMap === null || permissionSetDefinitionsMap === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId = permissionSetDefinitionsMap[permissionSetId]) === null || _permissionSetDefinitionsMap_permissionSetId === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId_permissionMap = _permissionSetDefinitionsMap_permissionSetId.permissionMap) === null || _permissionSetDefinitionsMap_permissionSetId_permissionMap === void 0 ? void 0 : _permissionSetDefinitionsMap_permissionSetId_permissionMap[rule];
        return permissionRule === null || permissionRule === void 0 ? void 0 : permissionRule.requestScope;
    }, [
        permissionSetDefinitionsMap
    ]);
    return {
        hasAccessToProjectResource,
        getRequestScopeForProjectResource
    };
};
const useHasAccessToFieldResourceInProject = ()=>{
    const { data: permissionSetDefinitionsMap } = usePermissionSetDefinitionsForCtxMap();
    const { data: accountData } = useAccountDataQuery();
    const userGroupIds = useMemo(()=>{
        var _ref;
        return ((_ref = accountData === null || accountData === void 0 ? void 0 : accountData.userProfile.user.userGroups) !== null && _ref !== void 0 ? _ref : []).map(({ userGroupsId })=>userGroupsId);
    }, [
        accountData === null || accountData === void 0 ? void 0 : accountData.userProfile.user.userGroups
    ]);
    const hasHasAccessToFieldResourceInProject = useCallback((rule, project, field)=>{
        var _project_permissionSet, _permissionSetDefinitionsMap_permissionSetId_permissionMap, _permissionSetDefinitionsMap_permissionSetId;
        if (rule == null) {
            return true;
        }
        const permissionSetId = project === null || project === void 0 ? void 0 : (_project_permissionSet = project.permissionSet) === null || _project_permissionSet === void 0 ? void 0 : _project_permissionSet.permissionSetId;
        if (permissionSetId == null) {
            return false;
        }
        const permissionRule = permissionSetDefinitionsMap === null || permissionSetDefinitionsMap === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId = permissionSetDefinitionsMap[permissionSetId]) === null || _permissionSetDefinitionsMap_permissionSetId === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId_permissionMap = _permissionSetDefinitionsMap_permissionSetId.permissionMap) === null || _permissionSetDefinitionsMap_permissionSetId_permissionMap === void 0 ? void 0 : _permissionSetDefinitionsMap_permissionSetId_permissionMap[rule];
        if (permissionRule == null || permissionRule.requestScope === 'NONE') {
            return false;
        }
        if (permissionRule.requestScope === 'GLOBAL' || permissionRule.requestScope === 'GROUP' || permissionRule.requestScope === 'LESS_RESTRICTED' || permissionRule.requestScope === 'RESTRICTED' || permissionRule.requestScope === 'PROJECT_OWNER' || permissionRule.requestScope === 'COMPANY_RESTRICTED') {
            return true;
        }
        if (permissionRule.requestScope === 'GROUP') {
            return userGroupIds.some((id)=>{
                var _field_userGroupIds;
                return ((_field_userGroupIds = field.userGroupIds) !== null && _field_userGroupIds !== void 0 ? _field_userGroupIds : []).includes(id);
            });
        }
        return false;
    }, [
        permissionSetDefinitionsMap,
        userGroupIds
    ]);
    return {
        hasHasAccessToFieldResourceInProject
    };
};
const useHasAccessToResourceAssociatedWithGroups = ()=>{
    var _accountData_userProfile_permissions_permissionSet, _accountData_userProfile_permissions, _accountData_userProfile;
    const { data: permissionSetDefinitionsMap, isLoading } = usePermissionSetDefinitionsForCtxMap();
    const { data: accountData } = useAccountDataQuery();
    const permissionSetId = accountData === null || accountData === void 0 ? void 0 : (_accountData_userProfile = accountData.userProfile) === null || _accountData_userProfile === void 0 ? void 0 : (_accountData_userProfile_permissions = _accountData_userProfile.permissions) === null || _accountData_userProfile_permissions === void 0 ? void 0 : (_accountData_userProfile_permissions_permissionSet = _accountData_userProfile_permissions.permissionSet) === null || _accountData_userProfile_permissions_permissionSet === void 0 ? void 0 : _accountData_userProfile_permissions_permissionSet.permissionSetId;
    const userGroupIds = useMemo(()=>{
        var _ref;
        return ((_ref = accountData === null || accountData === void 0 ? void 0 : accountData.userProfile.user.userGroups) !== null && _ref !== void 0 ? _ref : []).map(({ userGroupsId })=>userGroupsId);
    }, [
        accountData === null || accountData === void 0 ? void 0 : accountData.userProfile.user.userGroups
    ]);
    const hasAccessToResourceAssociatedWithGroups = useCallback((rule, resource)=>{
        var _permissionSetDefinitionsMap_permissionSetId_permissionMap, _permissionSetDefinitionsMap_permissionSetId;
        if (rule == null) {
            return true;
        }
        if (permissionSetId == null) {
            return false;
        }
        const permissionRule = permissionSetDefinitionsMap === null || permissionSetDefinitionsMap === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId = permissionSetDefinitionsMap[permissionSetId]) === null || _permissionSetDefinitionsMap_permissionSetId === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId_permissionMap = _permissionSetDefinitionsMap_permissionSetId.permissionMap) === null || _permissionSetDefinitionsMap_permissionSetId_permissionMap === void 0 ? void 0 : _permissionSetDefinitionsMap_permissionSetId_permissionMap[rule];
        if (permissionRule == null || permissionRule.requestScope === 'NONE') {
            return false;
        }
        if (permissionRule.requestScope === 'GLOBAL' || permissionRule.requestScope === 'LESS_RESTRICTED' || permissionRule.requestScope === 'RESTRICTED') {
            return true;
        }
        if (permissionRule.requestScope === 'GROUP') {
            return userGroupIds.some((id)=>resource.userGroupIds.includes(id));
        }
        return false;
    }, [
        permissionSetDefinitionsMap,
        permissionSetId,
        userGroupIds
    ]);
    return {
        hasAccessToResourceAssociatedWithGroups,
        isLoading
    };
};
export const useHasAccessToAccountResource = ()=>{
    var _accountData_userProfile_permissions_permissionSet, _accountData_userProfile_permissions, _accountData_userProfile, _accountData_userProfile_permissions_permissionSet1, _accountData_userProfile_permissions1, _accountData_userProfile1;
    const { data: permissionSetDefinitionsMap } = usePermissionSetDefinitionsForCtxMap();
    const { data: accountData } = useAccountDataQuery();
    const getRuleForResource = useCallback((rule)=>{
        var _accountData_userProfile_permissions_permissionSet, _accountData_userProfile_permissions, _accountData_userProfile, _permissionSetDefinitionsMap_permissionSetId_permissionMap, _permissionSetDefinitionsMap_permissionSetId;
        const permissionSetId = accountData === null || accountData === void 0 ? void 0 : (_accountData_userProfile = accountData.userProfile) === null || _accountData_userProfile === void 0 ? void 0 : (_accountData_userProfile_permissions = _accountData_userProfile.permissions) === null || _accountData_userProfile_permissions === void 0 ? void 0 : (_accountData_userProfile_permissions_permissionSet = _accountData_userProfile_permissions.permissionSet) === null || _accountData_userProfile_permissions_permissionSet === void 0 ? void 0 : _accountData_userProfile_permissions_permissionSet.permissionSetId;
        if (permissionSetId == null) {
            return undefined;
        }
        const permissionRule = permissionSetDefinitionsMap === null || permissionSetDefinitionsMap === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId = permissionSetDefinitionsMap[permissionSetId]) === null || _permissionSetDefinitionsMap_permissionSetId === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId_permissionMap = _permissionSetDefinitionsMap_permissionSetId.permissionMap) === null || _permissionSetDefinitionsMap_permissionSetId_permissionMap === void 0 ? void 0 : _permissionSetDefinitionsMap_permissionSetId_permissionMap[rule];
        if (permissionRule == null) {
            var _permissionSetDefinitionsMap_permissionSetId1;
            const defaultProjectPermission = permissionSetDefinitionsMap === null || permissionSetDefinitionsMap === void 0 ? void 0 : (_permissionSetDefinitionsMap_permissionSetId1 = permissionSetDefinitionsMap[permissionSetId]) === null || _permissionSetDefinitionsMap_permissionSetId1 === void 0 ? void 0 : _permissionSetDefinitionsMap_permissionSetId1.defaultProjectPermission;
            if (defaultProjectPermission != null) {
                var _permissionSetDefinitionsMap_defaultProjectPermission_permissionMap, _permissionSetDefinitionsMap_defaultProjectPermission;
                return permissionSetDefinitionsMap === null || permissionSetDefinitionsMap === void 0 ? void 0 : (_permissionSetDefinitionsMap_defaultProjectPermission = permissionSetDefinitionsMap[defaultProjectPermission]) === null || _permissionSetDefinitionsMap_defaultProjectPermission === void 0 ? void 0 : (_permissionSetDefinitionsMap_defaultProjectPermission_permissionMap = _permissionSetDefinitionsMap_defaultProjectPermission.permissionMap) === null || _permissionSetDefinitionsMap_defaultProjectPermission_permissionMap === void 0 ? void 0 : _permissionSetDefinitionsMap_defaultProjectPermission_permissionMap[rule];
            }
        }
        return permissionRule;
    }, [
        accountData === null || accountData === void 0 ? void 0 : (_accountData_userProfile = accountData.userProfile) === null || _accountData_userProfile === void 0 ? void 0 : (_accountData_userProfile_permissions = _accountData_userProfile.permissions) === null || _accountData_userProfile_permissions === void 0 ? void 0 : (_accountData_userProfile_permissions_permissionSet = _accountData_userProfile_permissions.permissionSet) === null || _accountData_userProfile_permissions_permissionSet === void 0 ? void 0 : _accountData_userProfile_permissions_permissionSet.permissionSetId,
        permissionSetDefinitionsMap
    ]);
    const hasAccessToAccountResource = useCallback((rule, actionScope = [])=>{
        var _accountData_userProfile_permissions_permissionSet, _accountData_userProfile_permissions, _accountData_userProfile;
        if (rule == null) {
            return true;
        }
        const permissionSetId = accountData === null || accountData === void 0 ? void 0 : (_accountData_userProfile = accountData.userProfile) === null || _accountData_userProfile === void 0 ? void 0 : (_accountData_userProfile_permissions = _accountData_userProfile.permissions) === null || _accountData_userProfile_permissions === void 0 ? void 0 : (_accountData_userProfile_permissions_permissionSet = _accountData_userProfile_permissions.permissionSet) === null || _accountData_userProfile_permissions_permissionSet === void 0 ? void 0 : _accountData_userProfile_permissions_permissionSet.permissionSetId;
        if (permissionSetId == null) {
            return false;
        }
        const permissionRule = getRuleForResource(rule);
        if (permissionRule == null) {
            return false;
        }
        // check if passed actionScope is there in permissionRule.actionScope from server
        // if the actionscope itself is not passed, then it is assumed that the user has access to the resource
        if (actionScope.length === 0 || actionScope && actionScope.every((scope)=>{
            var _permissionRule_actionScopes;
            return permissionRule === null || permissionRule === void 0 ? void 0 : (_permissionRule_actionScopes = permissionRule.actionScopes) === null || _permissionRule_actionScopes === void 0 ? void 0 : _permissionRule_actionScopes.includes(scope);
        })) {
            return true;
        }
        return false;
    }, [
        accountData === null || accountData === void 0 ? void 0 : (_accountData_userProfile1 = accountData.userProfile) === null || _accountData_userProfile1 === void 0 ? void 0 : (_accountData_userProfile_permissions1 = _accountData_userProfile1.permissions) === null || _accountData_userProfile_permissions1 === void 0 ? void 0 : (_accountData_userProfile_permissions_permissionSet1 = _accountData_userProfile_permissions1.permissionSet) === null || _accountData_userProfile_permissions_permissionSet1 === void 0 ? void 0 : _accountData_userProfile_permissions_permissionSet1.permissionSetId,
        getRuleForResource
    ]);
    return {
        hasAccessToAccountResource,
        getRuleForResource
    };
};
const isProject = (project)=>{
    if (Array.isArray(project)) {
        var _project_;
        if (project[0] === 'Project' && isNumber((_project_ = project[1]) === null || _project_ === void 0 ? void 0 : _project_.projectId)) {
            return true;
        }
        if (project[0] === 'project_id' && isNumber(project[1])) {
            return true;
        }
    }
    return false;
};
export const useWithAccess = ()=>{
    const { hasAccessToAccountResource } = useHasAccessToAccountResource();
    const { hasAccessToProjectResource, getRequestScopeForProjectResource } = useHasAccessToProjectResource();
    const { hasAccessToResourceAssociatedWithGroups, isLoading } = useHasAccessToResourceAssociatedWithGroups();
    const { hasHasAccessToFieldResourceInProject } = useHasAccessToFieldResourceInProject();
    const hasAccessToResource = useCallback(({ rule, resourceData, actionScope, projectId })=>{
        // if rule is not specified, then the user has access to the resource
        if (!rule) {
            return true;
        }
        const projectResourceId = isProject(resourceData) && (resourceData === null || resourceData === void 0 ? void 0 : resourceData[1]) || isProject(projectId) && (projectId === null || projectId === void 0 ? void 0 : projectId[1]);
        if (projectResourceId) {
            return hasAccessToProjectResource(rule, projectResourceId, actionScope);
        }
        if (resourceData == null) {
            return hasAccessToAccountResource(rule, actionScope);
        }
        const resourceName = resourceData === null || resourceData === void 0 ? void 0 : resourceData[0];
        switch(resourceName){
            case 'Field':
                return hasAccessToResourceAssociatedWithGroups(rule, resourceData[1]);
            case 'FieldResourceInProject':
                return hasHasAccessToFieldResourceInProject(rule, resourceData[1], resourceData[2]);
            default:
                return hasAccessToAccountResource(rule, actionScope);
        }
    }, [
        hasAccessToAccountResource,
        hasAccessToProjectResource,
        hasAccessToResourceAssociatedWithGroups,
        hasHasAccessToFieldResourceInProject
    ]);
    return {
        hasAccessToResource,
        getRequestScopeForProjectResource,
        isLoading
    };
};
export const useProjectAsRBACResource = (projectId)=>{
    const { data } = useProjectDetail(ProjectId(projectId));
    return useMemo(()=>ProjectResourceOrUndefined(data), [
        data
    ]);
};
